var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentTag,{tag:"component",class:[_vm.className, _vm.computedVariant, _vm.computedColor],style:({
    fontWeight: _vm.fontWeight,
    textTransform: _vm.textTransform,
    textAlign: _vm.textAlign,
    ..._vm.sx
  }),attrs:{"id":_vm.id}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }